import { styled } from '@mui/material/styles';
import { Box, TextField, Typography, InputAdornment } from '@mui/material';

export const SelectContainer = styled(Box)({
  position: 'relative',
});

export const StyledTextField = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    cursor: 'pointer',
  },
  '& .MuiOutlinedInput-input': {
    cursor: 'pointer',
    caretColor: 'transparent',
  },
});

export const StyledInputAdornment = styled(InputAdornment)({});

export const DropdownContainer = styled(Box)({
  position: 'absolute',
  top: '100%',
  zIndex: 1010,
  border: '1px solid #E0E0E0',
  borderRadius: '8px',
  backgroundColor: 'white',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  marginTop: '4px',
  overflow: 'hidden',
});

export const SearchInput = styled(TextField)({
  width: '100%',
  padding: '8px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 4px',
    '&::placeholder': {
      fontSize: '14px',
      opacity: 0.7,
    },
  },
});

export const OptionsContainer = styled(Box)({
  maxHeight: '250px',
  height: 'fit-content',
  overflowY: 'auto',
});

export const EmptyStateContainer = styled(Box)({
  padding: '16px 12px',
  textAlign: 'center',
});

export const EmptyStateText = styled(Typography)({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#9E9E9E',
});

interface OptionRowProps {
  isSelected?: boolean;
}

export const OptionRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<OptionRowProps>(({ isSelected }) => ({
  display: 'flex',
  padding: '10px 12px',
  cursor: 'pointer',
  backgroundColor: isSelected ? '#EEF4F3' : 'transparent',
  '&:hover': {
    backgroundColor: '#EEF4F3',
  },
  '&.disabled': {
    cursor: 'not-allowed',
  },
}));

interface ColumnCellProps {
  columnWidth?: string;
  columnFlex?: number;
}

export const ColumnCell = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'columnWidth' && prop !== 'columnFlex',
})<ColumnCellProps>(({ columnWidth, columnFlex }) => ({
  flex: columnFlex || (columnWidth ? 'none' : 1),
  width: columnWidth,
  flexShrink: columnWidth ? 0 : 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
}));

interface CellTextProps {
  isDisabled?: boolean;
}

export const CellText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})<CellTextProps>(({ isDisabled }) => ({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: isDisabled ? '#B4B4B4' : '#162936',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const ArrowIconStyles = (isOpen: boolean) => ({
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s ease-in-out',
});
